import { render, staticRenderFns } from "./Q4sCta.vue?vue&type=template&id=00a531cf&scoped=true"
import script from "./Q4sCta.vue?vue&type=script&lang=ts"
export * from "./Q4sCta.vue?vue&type=script&lang=ts"
import style0 from "./Q4sCta.vue?vue&type=style&index=0&id=00a531cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a531cf",
  null
  
)

export default component.exports